import { useRef } from 'react';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { ColorizedNameRenderer, OfferedReportStatusCellRenderer } from '../../utils/agGridUtils';
import TableGridItem from '../UI/TableGridItem';
import { useOfferedReportsSummary } from '../../hooks/api/offeredReports';
import type { Dayjs } from '@utils/dayjs';
import ColumnOption from '../../types/ColumnOption.interface';
import { EMPTY_VALUE, OfferedReportStatusText } from '../../types/OfferedReportSummary';

interface OfferedReportsTabProps {
    columnDefs: (ColDef & ColumnOption)[];
    date: Dayjs | string;
}

export default function OfferedReportsTab({ columnDefs, date }: OfferedReportsTabProps) {
    const gridRef = useRef(null);
    const { data: offeredReports } = useOfferedReportsSummary({ date, includeHistory: true });

    return (
        <TableGridItem
            ref={gridRef}
            defaultColDef={
                {
                    editable: true,
                    filter: true,
                    sortable: true,
                } as ColDef
            }
            columnDefs={columnDefs}
            rowData={offeredReports}
            groupDisplayType={'groupRows'}
            groupDefaultExpanded={-1}
            groupLockGroupColumns={-1}
            groupRowRendererParams={{
                innerRenderer: ({ value, node }: ICellRendererParams) => {
                    return node.field === 'hasOfferedReports'
                        ? OfferedReportStatusCellRenderer({ value: String(value || OfferedReportStatusText.UNDEFINED) })
                        : ColorizedNameRenderer({ value, emptyValue: EMPTY_VALUE });
                },
                suppressCount: true,
                emptyValue: EMPTY_VALUE,
            }}
            suppressMakeColumnVisibleAfterUnGroup={true}
        ></TableGridItem>
    );
}
